import { Modal } from 'antd';
import { useTranslation } from 'next-i18next';

interface AIErrorModalProps {
  open: boolean;
  title?: string;
  desc?: string | React.ReactNode;
  example?: string;
  btnTitle?: string;
  onClose?: (isOk: boolean) => void;
}

export default function AIErrorModal({ open, title, desc, example, btnTitle, onClose }: AIErrorModalProps) {
  const { t } = useTranslation('common');

  return (
    <Modal
      width={472}
      open={open}
      onCancel={() => onClose?.(true)}
      footer={null}
      destroyOnHidden
      centered
      styles={{
        content: {
          padding: 0,
          borderRadius: '12px',
          overflow: 'hidden',
        },
      }}
    >
      <div className="relative p-8">
        {/* 标题 */}
        {title && <h3 className="text-[20px] font-bold text-[#0c0c0c] leading-normal mb-4">{title}</h3>}

        {/* 描述 */}
        {desc && (
          <div className="text-[16px] font-normal text-[#0c0c0c] opacity-60 leading-6 mb-6">
            {typeof desc === 'string' ? (
              <div dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br />') }} />
            ) : (
              desc
            )}
          </div>
        )}

        {/* 示例区域 */}
        {example && (
          <div className="bg-[#f5f7f9] rounded-[12px] px-4 py-3.5 mb-6">
            <p className="text-[16px] leading-6 tracking-[-0.31px]">
              <span className="text-[#725cff] mr-2">e.g.</span>
              <span className="text-[#0c0c0c]">{example}</span>
            </p>
          </div>
        )}

        {/* 按钮 */}
        {btnTitle && (
          <button
            onClick={() => onClose?.(true)}
            className="w-full h-[42px] rounded-[27px] bg-gradient-to-b from-[#725cff] to-[rgba(141,131,255,0.8)] text-white text-[16px] font-semibold shadow-[0px_4px_12px_0px_rgba(114,92,255,0.2)] hover:opacity-90 transition-opacity"
          >
            {btnTitle}
          </button>
        )}
      </div>
    </Modal>
  );
}
